import Box from "./Box/Box";
import styles from "./Escolher.module.css";
import { FaShieldAlt, FaRocket } from "react-icons/fa";
import { BiSupport } from "react-icons/bi";
import { ImCogs } from "react-icons/im";
import { MdQueryStats } from "react-icons/md";

import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";


function Escolher() {
    useEffect(() => {
        AOS.init({ duration: 1000 });
    }, []);

    return (
        <div className={styles.choose}>
            <div className={styles.text}>
                <div className={styles.title} data-aos="fade-up">
                    O Seu Servidor em Piloto Automático
                </div>
                <div className={styles.divider} data-aos="fade-up"></div>
                <div className={styles.description} data-aos="fade-up">
                    Otimize o seu tempo com automações. Os nossos bots resolvem o trabalho repetitivo por você — simples e eficientes.
                </div>
            </div>
            <div className={styles.boxes}>
                <Box icon={<FaShieldAlt />} name={"Segurança Avançada"} detail={"Seus dados são totalmente criptografados e protegidos contra acessos não autorizados."} />
                <Box icon={<FaRocket />} name={"Estabilidade"} detail={"Hospedado em servidores de alta performance, garantindo que o bot esteja sempre online."} />
                <Box icon={<BiSupport />} name={"Suporte Dedicado"} detail={"Equipe dedicada pronta para ajudar você a qualquer momento, totalmente de graça."} />
                <Box icon={<ImCogs />} name={"Personalização Total"} detail={"Configure sua loja do jeito que preferir, com opções ilimitadas de personalização."} />
                <Box icon={<MdQueryStats />} name={"Estatísticas Detalhadas"} detail={"Acompanhe em tempo real todas as métricas das suas vendas e desempenho da sua loja."} />
            </div>
        </div>
    )
}

export default Escolher;